import React from 'react';

const InfoRow = ({ label, children, muted }) => (
  <div className="flex items-baseline justify-between py-[5px]">
    <span className="text-[12px] text-[#8993a4] select-none">{label}</span>
    <span className={`text-[13px] font-medium ${muted ? 'text-[#8993a4]' : 'text-[#2d3643]'}`}>
      {children}
    </span>
  </div>
);

const StripeStateCard = ({ state }) => {
  if (!state) {
    return (
      <div className="bg-white border border-[#e5e7eb] rounded-xl p-5">
        <span className="text-[13px] text-[#8993a4]">-</span>
      </div>
    );
  }

  const formatDate = (val) => {
    try { return new Date(val).toLocaleString(); } catch { return val; }
  };

  return (
    <div className="bg-white border border-[#e5e7eb] rounded-xl overflow-hidden">
      <div className="px-5 py-3">
        {state.status && (
          <InfoRow label="Status">
            <span className={`text-[11px] font-semibold px-2 py-0.5 rounded ${
              state.status === 'pending' ? 'bg-[#FEF9C3] text-[#854D0E]' :
              state.status === 'approved' ? 'bg-[#DBEAFE] text-[#1E40AF]' :
              state.status === 'rejected' ? 'bg-[#FEE2E2] text-[#991B1B]' :
              state.status === 'completed' ? 'bg-[#D1FAE5] text-[#065F46]' :
              'bg-[#F3F4F6] text-[#374151]'
            }`}>
              {state.status.charAt(0).toUpperCase() + state.status.slice(1)}
            </span>
          </InfoRow>
        )}

        {state.stripeAccountId !== undefined && (
          <InfoRow label="Stripe Account" muted>
            {state.stripeAccountId ? (
              <span style={{ fontFamily: 'monospace', fontSize: 12 }}>{state.stripeAccountId}</span>
            ) : (
              <span className="text-[#9CA3AF] italic">Removed</span>
            )}
          </InfoRow>
        )}

        {state.reason && (
          <InfoRow label="Request Reason" muted>{state.reason}</InfoRow>
        )}

        {state.rejectionReason && (
          <InfoRow label="Rejection Reason" muted>{state.rejectionReason}</InfoRow>
        )}

        {state.approvedBy && (
          <InfoRow label="Approved By" muted>{state.approvedBy}</InfoRow>
        )}

        {state.rejectedBy && (
          <InfoRow label="Rejected By" muted>{state.rejectedBy}</InfoRow>
        )}

        {state.approvedAt && (
          <InfoRow label="Approved At" muted>{formatDate(state.approvedAt)}</InfoRow>
        )}

        {state.replacementTokenExpiry && (
          <InfoRow label="Link Expires" muted>{formatDate(state.replacementTokenExpiry)}</InfoRow>
        )}

        {state.requestId && (
          <InfoRow label="Request ID" muted>
            <span style={{ fontFamily: 'monospace', fontSize: 11 }}>{state.requestId}</span>
          </InfoRow>
        )}
      </div>
    </div>
  );
};

export default StripeStateCard;
